module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/sort-2-a7909bf337e84de05b2266540efef41a.svg";